var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var SpaStore = /** @class */ (function () {
    function SpaStore(initialState) {
        this.eventListeners = new Map();
        this.stateListeners = new Map();
        this.nameKeyMap = new Map();
        this.startKey = Date.now();
        // @ts-ignore
        this.state = initialState ? initialState : {};
    }
    SpaStore.prototype.fireStateChange = function () {
        var e_1, _a;
        try {
            for (var _b = __values(this.stateListeners.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var listener = _c.value;
                listener(Object.assign({}, this.state));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    SpaStore.prototype.getUUID = function () {
        return (this.startKey++).toString();
    };
    SpaStore.prototype.setState = function (newstate) {
        this.state = __assign(__assign({}, this.state), newstate);
        this.fireStateChange();
    };
    SpaStore.prototype.getState = function (name) {
        var state = Object.assign({}, this.state);
        if (name) {
            return state[name] || {};
        }
        return state;
    };
    /**
     * 订阅state改变
     * @param callback
     * @returns key
     */
    SpaStore.prototype.subscribeState = function (callback) {
        var key = this.getUUID();
        this.stateListeners.set(key, callback);
        return key;
    };
    /**
     * 取消订阅state
     * @param key
     */
    SpaStore.prototype.unsubscribeState = function (key) {
        this.stateListeners.delete(key);
    };
    /**
     * 手动触发自定义事件，类似eventbus
     * @param name
     * @param args
     */
    SpaStore.prototype.emit = function (name) {
        var e_2, _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.eventListeners.has(name)) {
            var listeners = this.eventListeners.get(name);
            try {
                for (var _b = __values(listeners.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var listener = _c.value;
                    listener.apply(null, args);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    };
    /**
     * 订阅自定义事件，类似eventbus
     * @param name
     * @param callback
     */
    SpaStore.prototype.on = function (name, callback) {
        var listeners = undefined;
        var key = this.getUUID();
        if (this.eventListeners.has(name)) {
            listeners = this.eventListeners.get(name);
        }
        else {
            listeners = new Map();
            this.eventListeners.set(name, listeners);
        }
        listeners.set(key, callback);
        this.nameKeyMap.set(key, name);
        return key;
    };
    /**
     * 清理事件监听
     * @param key
     */
    SpaStore.prototype.off = function (key) {
        var e_3, _a;
        if (this.eventListeners.has(key)) {
            this.eventListeners.delete(key);
            try {
                for (var _b = __values(this.nameKeyMap.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var arr = _c.value;
                    var _d = __read(arr, 2), _key = _d[0], _value = _d[1];
                    if (_value === key) {
                        this.nameKeyMap.delete(_key);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return;
        }
        if (this.nameKeyMap.has(key)) {
            var name_1 = this.nameKeyMap.get(key);
            if (this.eventListeners.has(name_1)) {
                var listeners = this.eventListeners.get(name_1);
                listeners.delete(key);
                this.nameKeyMap.delete(key);
            }
        }
    };
    /**
     * 清理所有订阅和state
     */
    SpaStore.prototype.clearAll = function () {
        // @ts-ignore
        this.state = {};
        this.nameKeyMap.clear();
        this.stateListeners.clear();
        this.eventListeners.clear();
    };
    return SpaStore;
}());
export { SpaStore };
export var getSpaStore = function () {
    if (!window.spa_store) {
        window.spa_store = new SpaStore();
    }
    return window.spa_store;
};
export function loadChildApp(app) {
    var jsFiles = app.jsFiles, cssFiles = app.cssFiles;
    var version = app.version;
    jsFiles = jsFiles || [];
    cssFiles = cssFiles || [];
    var length = jsFiles.length;
    var completes = [];
    var store = getSpaStore();
    var state = store.getState("childAppLoaded");
    if (state[app.name]) {
        return Promise.resolve(window[app.name]);
    }
    return new Promise(function (resolve, reject) {
        if (length === 0) {
            resolve();
            return;
        }
        function onload(src) {
            completes.push(src);
            if (completes.length === length) {
                state[app.name] = true;
                store.setState({ childAppLoaded: state });
                resolve(window[app.name]);
            }
        }
        if (jsFiles.length) {
            try {
                jsFiles.forEach(function (item) {
                    if (document.getElementById("" + item)) {
                        onload(item);
                    }
                    else {
                        var script = document.createElement("script");
                        script.id = item;
                        script.src = item + "?v=" + version;
                        script.async = false;
                        script.defer = true;
                        script.onload = function () { return onload(item); };
                        script.onerror = reject;
                        document.head.append(script);
                    }
                });
            }
            catch (error) {
                reject(error);
            }
        }
        if (cssFiles.length) {
            try {
                cssFiles.forEach(function (item) {
                    if (document.getElementById("" + item)) {
                        return;
                    }
                    var link = document.createElement("link");
                    link.id = item;
                    link.rel = "stylesheet";
                    link.type = "text/css";
                    link.href = item + "?v=" + version;
                    document.head.append(link);
                });
            }
            catch (error) {
                reject(error);
            }
        }
    });
}
export function getSpaRoutes(apps) {
    return apps
        .filter(function (app) { return app.ignoreRouter !== true; })
        .map(function (app) { return ({ name: app.name, path: app.path }); });
}
